import { createQueryString } from '@eika-infrastruktur/utils';

import type {
    ApprovalResult,
    EFaktura,
    EFakturaAddGivenPermissionRequest,
    EFakturaGivenPermission,
    EFakturaId,
    EFakturaPaymentRequest,
    EFakturaPermissionId,
    EFakturaReceivedPermission,
    EFakturaUpdateGivenPermissionRequest,
    ValidateEFakturaPermissionRequest,
    ValidateEfakturaPermissionResponse,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { del, get, post, put } from './request';

export const SERVICE_PATH = 'rest/resource/efaktura';

export function getEFakturas(): Promise<EFaktura[]> {
    return get<EFaktura[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export function getInvoice(id: EFakturaId): Promise<string> {
    return get<string>(`${CONTEXT_PATH}/${SERVICE_PATH}/${id.value}/invoice`);
}

export function payEfaktura(
    id: EFakturaId,
    efakturaPayment: EFakturaPaymentRequest,
    acceptDuplicate = false,
): Promise<ApprovalResult> {
    const queryString = createQueryString({
        acceptDuplicate: acceptDuplicate.toString(),
    });
    return post<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/${id.value}${queryString}`, efakturaPayment);
}

export function deleteEFaktura(id: EFakturaId): Promise<unknown> {
    return del(`${CONTEXT_PATH}/${SERVICE_PATH}/${id.value}/delete`);
}

export function getGivenSharedEfakturas() {
    return get<EFakturaGivenPermission[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/permissions/given`);
}

export function getReceivedSharedEfakturas() {
    return get<EFakturaReceivedPermission[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/permissions/received`);
}

export function addEfakturaGivenPermission(request: EFakturaAddGivenPermissionRequest) {
    return post<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/permissions`, request);
}

export function updateEfakturaPermissions(id: EFakturaPermissionId, request: EFakturaUpdateGivenPermissionRequest) {
    return put<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/permissions/${id.value}/update`, request);
}

export function deleteGivenEfakturaPermission(id: EFakturaPermissionId) {
    return del<void>(`${CONTEXT_PATH}/${SERVICE_PATH}/permissions/given/${id.value}`);
}

export function deleteReceivedEfakturaPermission(id: EFakturaPermissionId) {
    return del<void>(`${CONTEXT_PATH}/${SERVICE_PATH}/permissions/received/${id.value}`);
}

export function validateUser(request: ValidateEFakturaPermissionRequest) {
    return post<ValidateEfakturaPermissionResponse>(
        `${CONTEXT_PATH}/${SERVICE_PATH}/permissions/validateuser`,
        request,
    );
}
